import { NgModule } from '@angular/core';
import { BannersRoutingModule } from './banners-routing-module';

@NgModule({
  declarations: [
  ],
  imports: [
    BannersRoutingModule
  ],
  exports: [
  ],
})
export class BannersModule {
}
